<div class="container">
  <p class="buyer-purescore-script-report report-title-spacing">
    Buyer Purescore Script Report
  </p>

  <div class="row">
    <!-- Buyer Selection -->
    <div class="form-group text-center col-md-4">
      <label for="buyerName">Buyer Name</label>
      <ps-ui-select-dropdown
        [multi]="true"
        [enableSearch]="true"
        [dropdownItems]="buyers"
        [field]="'name'"
        labelNone="Select Buyer"
        (selectedItems)="selectCompanies($event)"
      >
      </ps-ui-select-dropdown>
      <div class="form-group text-center col-md-4"></div>
    </div>

    <!-- Optional Survey ID -->
    <div class="form-group text-center col-md-4">
      <label for="surveyId">Survey ID</label>
      <input
        id="surveyId"
        class="form-control input-height-align"
        type="text"
        placeholder="Enter Survey ID"
        [(ngModel)]="surveyId"
        name="surveyId"
      />
    </div>

    <!-- Date Range -->
    <div class="form-group col-xs-12 col-md-4 text-center">
      <label for="dateRange">Date Range</label>
      <input
        class="form-control date-range input-height-align"
        type="text"
        name="daterangeInput"
        daterangepicker
        [options]="datapickerOptions"
        (selected)="selectedDate($event)"
      />
    </div>
  </div>
</div>

<!-- Submit Action Button -->
<div class="row mt-12 justify-content-center">
  <div class="hasing-buttons mt-6 col-sm-4">
    <button
      class="btn submit-btn"
      type="submit"
      psUiButton
      color="primary"
      size="large"
      (click)="getReport()"
    >
      Find
    </button>
    <button
      *ngIf="reportData && reportData.length > 0"
      class="btn download-btn"
      type="button"
      psUiButton
      color="secondary"
      size="large"
      (click)="downloadReport()"
    >
      Download Report
    </button>
  </div>
</div>

<!-- Stats Data Table -->

<div class="row mt-4">
  <div
    class="col-md-12 table-responsive"
    *ngIf="reportData && reportData.length > 0"
  >
    <table class="table table-striped border mt-1">
      <thead class="not-fixed">
        <tr>
          <th
            scope="column"
            *ngFor="let column of columns"
            [psSortTable]="reportData"
            [attr.data-name]="column"
          >
            {{ column }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of reportData">
          <td *ngFor="let column of columns">
            {{ (data[column] ?? '') !== '' ? data[column] : 'N/A' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
